import { useState, useCallback } from 'react';

export const useSwipe = (onSwipeLeft, onSwipeRight) => {
  const [touch, setTouch] = useState({
    touchStart: 0,
    touchEnd: 0
  });

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouch(state => ({
      ...state,
      touchEnd: 0,
      touchStart: e.targetTouches[0].clientX
    }));
  };

  const onTouchMove = (e) => {
    setTouch(state => ({
      ...state,
      touchEnd: e.targetTouches[0].clientX
    }));
  };

  const onTouchEnd = useCallback(() => {
    if (!touch.touchStart || !touch.touchEnd) return;

    const distance = touch.touchStart - touch.touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      onSwipeLeft();
    }
    if (isRightSwipe) {
      onSwipeRight();
    }
  }, [touch.touchStart, touch.touchEnd, onSwipeLeft, onSwipeRight]);

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
};